import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const rawAdminAllowlist = import.meta.env.VITE_ADMIN_EMAIL_ALLOWLIST || '';

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);
export const CMS_CONTENT_ROW_ID = 'primary';
export const CMS_STORAGE_BUCKET = import.meta.env.VITE_SUPABASE_STORAGE_BUCKET || 'site-assets';
export const adminEmailAllowlist = rawAdminAllowlist
  .split(',')
  .map((email) => email.trim().toLowerCase())
  .filter(Boolean);

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

export function isAllowedAdminEmail(email?: string | null) {
  if (!email) {
    return false;
  }

  if (adminEmailAllowlist.length === 0) {
    return true;
  }

  return adminEmailAllowlist.includes(email.trim().toLowerCase());
}
